import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { CheckIcon } from "../../SvgComponents/CheckIcon/CheckIcon";

export const SignatureReasonModal = ({ showSignatureReasonModal, setShowSignatureReasonModal, reason }) => {
    const { t } = useTranslation();

    return (
        <>
            <Modal
                title={t("document_detail.signature_reason_title")}
                footer={null}
                open={showSignatureReasonModal}
                closable={false}
            >
                <div className="modal-container disclaimer-modal">
                    <p className="nu-input-label">{reason}</p>
                    <Col className="action-buttons mobile-button">
                        <Row>
                            <Col md={3} xs={3}></Col>
                            <Col md={6} xs={6}>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-active"
                                    onClick={() => setShowSignatureReasonModal(false)}
                                >
                                    <span className="cancel-text">{t("general.ok")}</span>
                                    <CheckIcon />
                                </button>
                            </Col>
                            <Col md={3} xs={3}></Col>
                        </Row>
                    </Col>
                </div>
            </Modal>
        </>
    );
};
